module.exports = __webpack_public_path__ + "static/bna-4e3660aab6ae9fcbe414762e46366603.png";